import { ThumbnailTypes } from 'src/components/thumbnail/types';
import { GQL_QUERIES } from 'src/utils/analytics/newrelic/ErrorTracker';
import { DynamicObject } from 'src/utils/commonTypes';
import { DisplayLanguage } from 'src/utils/constants/stringConstants';

import SimpleStore from '../../../store/SimpleStore';
import {
  HTTP_HEADER_KEYS,
  HTTP_URL_PARAMS
} from '../../../utils/constants/HttpMethodsConstants';
import { FETCH_UP_NEXT_EPISODES } from '../../GraphQL/Queries/UpnextEpisodesQuery';
import { graphQlRequest } from '../../GraphQL/RequestHandler';
import { fetchTvShowGenreData } from '../TvShowDetailsPage/TvShowDetailsPageService';

const generateUpnextEpisodesQueryParams = (
  episodeId: string,
  seasonId: string
) => {
  const displayLanguage = SimpleStore.get(HTTP_URL_PARAMS.DISPLAY_LANGUAGE);
  const country = SimpleStore.get(HTTP_URL_PARAMS.COUNTRY_CODE);
  const queryParams = {
    filter: {
      page: 1,
      limit: 25,
      country,
      translation: displayLanguage,
      type: 'next',
      episodeId: episodeId,
      seasonId
    }
  };
  return queryParams;
};

export const fetchUpnextEpisodes = async (
  episodeId: string,
  seasonId: string
): Promise<any> => {
  try {
    const response: any = await graphQlRequest(
      FETCH_UP_NEXT_EPISODES,
      generateUpnextEpisodesQueryParams(episodeId, seasonId),
      GQL_QUERIES.FETCH_UP_NEXT_EPISODES
    );
    return response.upNextEpisodes || {};
  } catch (error) {
    console.error('Error while fetching latest movies: ', error);
    return {};
  }
};

export const getRecommendedContents = async (reqObj: DynamicObject) => {
  const {
    episodeId,
    seasonId,
    contentLanguage,
    type,
    genres,
    allLang,
    translationsData
  } = reqObj;
  const upnextEpisodesData = await fetchUpnextEpisodes(episodeId, seasonId);
  /**
   *  The first object indicates Movies You May Like rail,
   *  but this rail won't be there in tv-shows/web-series
   *  Hence passing empty object
   */
  if (upnextEpisodesData?.contents?.length) {
    return {
      recommendedContentData: [{}, upnextEpisodesData],
      thumbnailType: ThumbnailTypes.upnext
    };
  } else {
    const headers = [
      HTTP_HEADER_KEYS.X_ACCESS_TOKEN,
      HTTP_HEADER_KEYS.AUTHORIZATION
    ];
    const genreRailApiResponse = await fetchTvShowGenreData(
      contentLanguage,
      type,
      genres,
      allLang,
      translationsData,
      headers
    );
    return {
      recommendedContentData: [{}, genreRailApiResponse[0]],
      thumbnailType: ThumbnailTypes.vertical
    };
  }
};
